export const GET_SAVED_LIST_PROFILES_DATA = 'GET_SAVED_LIST_PROFILES_DATA';
export const DELETE_SAVED_LIST_PROFILE = 'DELETE_SAVED_LIST_PROFILE';
